import dayjs from 'dayjs'
import $http from '@/fetch'

const getFileSize = (size = 0) => {
  if (isNaN(Number(size))) return size

  let bytes = ['B', 'KB', 'MB', 'GB', 'TB']
  let i = 0
  while (parseInt(size / 1024)) {
    ++i
    size = size / 1024
  }
  return `${Number(size).toFixed(2)} ${bytes[i]}`
}

export default {
  state: {
    currentStore: [],
    hasNext: false,
    pageSize: 50,
  },
  mutations: {
    INIT_CURRENT_STORE(state, { downloadable, files, createdAt }) {
      const currentStore = files.map(file => Object.assign(file, {
        downloadable,
        _size: getFileSize(file.size),
        _createdAt: dayjs(+file.createdAt).locale('en-us').format('MMM DD, YYYY'),
        sharedAt: createdAt
      }))

      state.hasNext = files.length >= state.pageSize
      state.currentStore = state.currentStore.concat(currentStore)
    },
    UPDATE_HAS_NEXT_PAGE(state, hasNext = false) {
      state.hasNext = hasNext
    },
    RESET_FILES_STATE(state) {
      state.hasNext = false
      state.currentStore = []
    },
  },
  actions: {
    GET_FILES_BY_SHAREID({ state, commit }, shareId) {
      const len = state.currentStore.length
      const last = len ? state.currentStore[len - 1] : null
      const params = {
        t: new Date().getTime(),
        perPage: state.pageSize
      }

      if (last) {
        Object.assign(params, {
          startFromId: last.id,
          startFromCreatedAt: last.createdAt
        })
      }

      commit('UPDATE_HAS_NEXT_PAGE', false)

      return $http.get(`/shares/${shareId}/`, {
        params
      }).then(result => {
        commit('INIT_CURRENT_STORE', result)
      })
    }
  },
  getters: {
    hasNextPage: state => state.hasNext,
    currentStore: state => state.currentStore
  }
}
